import { InjectionToken } from '@angular/core';
import { BaseApiClientRisksService } from '../base-api-client-risks.service';

export const API_CLIENT_RISKS_SERVICE = new InjectionToken<BaseApiClientRisksService>(
  'BaseApiClientRisksService'
);